<template lang="pug">
  v-card.mb-3
    v-card-title {{extra.name}}
    v-card-text
      ul
        li(v-for="job in rawJobs" :key="job.id")
          | {{ job.projekt.name }} &#32;
          a(:href="job.link") {{job.name}}

</template>

<script>
import gql from 'graphql-tag'

export default {
  props: ['extra'],
  data() {
    return {
      jobs: [],
      projekte: [],
    }
  },
  apollo: {
    jobs: {
      query: gql`{
        jobs {
          id
          name
          link
          raw
        }
        projekte {
          id
          name
          pid
        }
      }`,
      update(response) {
        this.projekte = response.projekte || []
        return response.jobs
      }
    }
  },
  computed: {
    rawJobs() {
      const projekte = this.projekte
      return this.jobs.map(job => {
        const raw = JSON.parse(job.raw)
        const projektId = `${raw.config.ProjectReferenceID || ''}`.replace(/^[Pp]/, '') || null
        const projekt = projektId && projekte.find(projekt => projekt.pid == projektId ) || { name: projektId || '' }
        return {...job, projekt, raw, internal: raw.internal }
      }).filter((j) => j.internal)
    }
  },
  method() {

  }
}
</script>
